import React, { useEffect, useMemo, useState } from 'react';
import { useMediaQuery, useDebouncedValue } from '@mantine/hooks';
import Navigation from '../sidebar/Navigation';
import { useNavigate } from 'react-router-dom';
import { createB2BAPI } from '../../../api/Interceptor';
import { BASE_URL } from '../../../api/EndPoints';
import notify from '../../../utils/Notification';
import { IconX } from '@tabler/icons-react';
import { Button, TextInput, Loader, Skeleton } from '@mantine/core';
import InfiniteScroll from 'react-infinite-scroll-component';
import './MtoEnquiry.css';

const MtoEnquiry = () => {
    const isMobile = useMediaQuery('(max-width: 767px)');
    const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 991px)');

    const navigate = useNavigate();
    const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);

    const pageSize = 10;

    const [inquiries, setInquiries] = useState([]);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(true);

    const [loadingInitial, setLoadingInitial] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [hasLoaded, setHasLoaded] = useState(false);

    const [profile, setProfile] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearch] = useDebouncedValue(searchTerm, 500);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState(new Date().toISOString().split("T")[0]);
const [totalCount, setTotalCount] = useState(0);
    useEffect(() => {
        fetchProfile();
    }, []);
console.log(totalCount,"mkmkkm")
    useEffect(() => {
        if (profile?.customerId) {
            setPage(0);
            setInquiries([]);
             fetchCount();     
            fetchInquiries(0, true);
        }
    }, [profile?.customerId, debouncedSearch, fromDate, toDate]);

    const fetchProfile = async () => {
        try {
            const res = await B2B_API.get("customer/profile").json();
            setProfile(res.response);
        } catch (err) {
            console.error(err);
            setLoadingInitial(false);
        }
    };
const fetchCount = async () => {
        try {
            const params = new URLSearchParams({
                isMapped: "true",
                searchTerm: debouncedSearch || "",
                fromDate: formatDateForAPI(fromDate),
                toDate: formatDateForAPI(toDate),
                customerId: profile?.customerId || ""
            });

            const response = await B2B_API.get(`madeToOrder/getAllMtocount?${params.toString()}`);
            const data = await response.json();
            setTotalCount(data.response || 0);
       } catch (err) {
            console.error(err);
        }
    };
    const formatDateForAPI = (dateStr) => {
        if (!dateStr) return "";
        const [y, m, d] = dateStr.split('-');
        return `${d}/${m}/${y}`;
    };

    const buildQuery = (currentPage) => {
        const params = new URLSearchParams({
            isMapped: "true",
            page: currentPage,
            size: pageSize,
            searchTerm: debouncedSearch || "",
            fromDate: formatDateForAPI(fromDate),
            toDate: formatDateForAPI(toDate),
            customerId: profile?.customerId || ""
        });

        return `madeToOrder/getAll?${params.toString()}`;
    };

    const fetchInquiries = async (currentPage, isInitial = false) => {
        try {
            if (isInitial) setLoadingInitial(true);
            else setLoadingMore(true);

            const response = await B2B_API.get(buildQuery(currentPage));
            const data = await response.json();

            const newData = data?.response?.content || [];

            setInquiries(prev =>
                currentPage === 0 ? newData : [...prev, ...newData]
            );

            setHasMore(newData.length === pageSize);
            setHasLoaded(true);

        } catch (error) {
            notify({
                id: 'fetch_inquiries',
                error: true,
                title: error?.message || 'Failed to load enquiries',
            });
        } finally {
            setLoadingInitial(false);
            setLoadingMore(false);
        }
    };

    const loadMore = () => {
        const nextPage = page + 1;
        setPage(nextPage);
        fetchInquiries(nextPage, false);
    };

    const resetFilters = () => {
        setSearchTerm('');
        setFromDate('');
        setToDate(new Date().toISOString().split("T")[0]);
    };

    const formatDisplayDate = (timestamp) => {
        if (!timestamp) return "-";
        const date = new Date(timestamp);
        return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
    };

    return (
        <div className="view-my-page router-view-container">

            {(!isMobile && !isTablet) && <Navigation />}

            <div className="view-fabric-inquiries-v2 route-view">

                <div className="mto-container">

                    {/* HEADER */}
                    <div className="mto-header">
                        <h1 className="mto-title">
                            Made To Order Enquiries
                            <span className="mto-count-badge">{totalCount}</span>
                        </h1>
                    </div>

                    {/* FILTERS */}
                    <div className="mto-filters">

                        <TextInput
                            placeholder="Search"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />

                        <TextInput
                            type="date"
                            value={fromDate}
                            max={toDate}
                            onChange={(e) => setFromDate(e.target.value)}
                        />

                        <TextInput
                            type="date"
                            value={toDate}
                            min={fromDate}
                            onChange={(e) => setToDate(e.target.value)}
                        />

                        <Button
                            onClick={resetFilters}
                            color="red"
                            variant="light"
                             disabled={!searchTerm && !fromDate}
                            leftSection={<IconX size={16} />}
                        >
                            Clear
                        </Button>
                    </div>

                    {loadingInitial && inquiries.length === 0 && (
                        <div className="mto-grid">
                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => (
                                <div key={n} className="mto-product-card" style={{ padding: 0 }}>
                                    <Skeleton height={180} radius={0} />
                                    <div className="mto-body">
                                        <div className="mto-top" style={{ marginBottom: '8px' }}>
                                            <Skeleton height={14} width="40%" />
                                            <Skeleton height={14} width="30%" />
                                        </div>
                                        <Skeleton height={16} width="70%" mb={8} />
                                        <Skeleton height={14} width="30%" mb={12} />
                                        <div className="mto-vendor-row">
                                            <Skeleton height={20} width="60px" radius="xl" />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* EMPTY STATE */}
                    {!loadingInitial && hasLoaded && inquiries.length === 0 && (
                        <div className="empty-state">
                            No Made To Order Enquiries found
                        </div>
                    )}

                    {/* INFINITE SCROLL */}
                    <InfiniteScroll
                        dataLength={inquiries.length}
                        next={loadMore}
                        hasMore={hasMore}
                        loader={
                            loadingMore && (
                                <div className="loading-container">
                                    <Loader color="var(--primary)" />
                                </div>
                            )
                        }
                        endMessage={
                            hasLoaded && inquiries.length > 0 && (
                                <p className="end-message">
                                    You've seen all enquiries
                                </p>
                            )
                        }
                    >
                        <div className="mto-grid">
                            {inquiries.map((item) => (
                                <div
                                    key={item.id}
                                    className="mto-product-card"
                                    onClick={() => navigate(item.landingUrl)}
                                >

                                    {/* IMAGE */}
                                    <div className="mto-image-wrapper">
                                        <img
                                            className="mto-image"
                                            src={
                                                item.variantImage
                                                    ? item.variantImage.startsWith("http")
                                                        ? item.variantImage
                                                        : `${BASE_URL.replace("/api", "")}${item.variantImage}`
                                                    : "/no-image.png"
                                            }
                                            alt="variant"
                                        />
                                        <span className="mto-date">
                                            {item.mtoEnquiryId}
                                        </span>
                                    </div>

                                    {/* BODY */}
                                    <div className="mto-body">

                                        <div className="mto-top">
                                            <div className="mto-status">
                                                {item.enquiryStatus}
                                            </div>

                                            {item?.enquiryStatus === "VENDOR_LINKED" && (
                                                <span className="mto-vendor-chip">
                                                    {item.vendorName || "Vendor Linked"}
                                                </span>
                                            )}
                                        </div>

                                        <div className="mto-title-row" style={{ display: "flex", alignItems: "center", gap: "8px" }}>

                                            <div className="mto-title-name">
                                                {item.variantName || "-"}
                                            </div>

                                            <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                                                {(item.colorCodes || []).map((color, idx) => (
                                                    <span
                                                        key={idx}
                                                        title={color}
                                                        style={{
                                                            width: "12px",
                                                            height: "12px",
                                                            borderRadius: "5px",
                                                            backgroundColor: color,
                                                            border: "1px solid #ccc",
                                                            display: "inline-block"
                                                        }}
                                                    />
                                                ))}
                                            </div>

                                        </div>

                                        <div className="quality-price">
                                            <b>₹ {item.costPrice}</b>
                                        </div>

                                        <div className="mto-vendor-row">

                                            <span
                                                className={`mto-status-badge ${item.madeToOrderVerified ? "verified" : "not-verified"
                                                    }`}
                                            >
                                                {item.madeToOrderVerified ? "Verified" : "Not Verified"}
                                            </span>
                                        </div>

                                    </div>
                                </div>
                            ))}
                        </div>
                    </InfiniteScroll>

                </div>
            </div>
        </div>
    );
};

export default MtoEnquiry;